// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"SignUpPage_formWrapper__en2lT"};